import * as Api from '@/helpers/restApi'
import { unwrapFormEditorHtml } from '@/helpers/unwrapEditorHtml.js'

export default {
  state: {
    ProductsDataTable: []
  },
  getters: {
    getProductsDataTable: state => state.ProductsDataTable
  },
  mutations: {
    // SetProductForm (state, val) {
    //   state.ProductForm = val
    // }
  },
  actions: {
    setProductsDataTable ({ state, dispatch }, url) {
      // ПОЛУЧАЕМ ОБЪЕКТ ДЛЯ productsListTable страница товаров
      Api.getApi({
        url
      })
        .then((data) => {
          if (data.Succeeded) {
            state.ProductsDataTable = data.Data
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setStatusProductsTable ({ dispatch }, params) {
      // публикуем и снимаем с публикации прямо из таблицы
      return Api.putApi({
        url: params.url,
        payload: params.obj
      })
        .then((data) => {
          if (!data.Succeeded) {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setDeleteProducts ({ dispatch }, url) {
      // удаление товара из таблицы
      return Api.deleteApi({
        url
      })
        .then((data) => {
          if (!data.Succeeded) {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setCloneProducts ({ dispatch }, url) {
      // клонирование товара в таблице
      return Api.putApi({
        url
      })
        .then((data) => {
          if (!data.Succeeded) {
            // dispatch('setProductsDataTable')
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setProductForm ({ commit, dispatch }, url) {
      // получаем объект тела новости для редактир или созд новой
      return Api.getApi({
        url
      })
        .then((data) => {
          if (data.Succeeded) {
            commit('SetFormData', data.Data)
            // глубокое копирование оригинального объекта
            commit('SetOriginFormData', data.Data)
            commit('SetShowSelectedTags', data.Data.InnerTags)
            commit('SetShowSelectedKeywords', data.Data.SearchTags)
            dispatch('setClearCacheInnerTag')
            dispatch('setClearCacheInnerKeywords')
            dispatch('setClearCacheInnerTagServices')
            dispatch('setClearCacheInnerKeywordsServices')
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setSaveProduct ({ getters, dispatch, commit }, url) {
      const payload = unwrapFormEditorHtml({ ...getters.getFormData })
      return Api.putApi({
        url,
        payload
      })
        .then((data) => {
          if (!data.Succeeded) {
            dispatch('setShowErrorModal', data)
            return Promise.reject(new Error('setSaveProduct failed'))
          }
          commit('SetFormDataId', data.Data.Value)
          if (payload.DefferedDate !== null) {
            return dispatch('setDefferedDateProduct', {
              Value: payload.DefferedDate,
              Id: data.Data.Value
            })
          }
        })
    },
    setToggleProductPublish ({ dispatch }, params) {
      // снятие с публикации и опубликование из страницы
      // редактора
      Api.putApi({
        url: params.url,
        payload: { Value: params.publish }
      })
        .then((data) => {
          if (!data.Succeeded) {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setDefferedDateProduct ({ dispatch }, obj) {
      // Для установления отложенной даты публикации
      return Api.putApi({
        url: `/api/Articles/SetDefferedDate/${obj.Id}`,
        payload: { Value: obj.Value }
      })
        .then((data) => {
          if (data.Succeeded) {
            // state.FormData.Id = data.Data.Value
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    }
  }
}
